function camelToKebab(camelCase) {
    return camelCase.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
}

export { camelToKebab };
//# sourceMappingURL=camel-to-kebab.js.map
